
import "bootstrap/dist/css/bootstrap.css";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

const awards = [
    {
        date: "2023",
        html: "<a href='https://tc.computer.org/vgtc/awards/vis-doctoral-dissertation-award/'  class='url'>IEEE VGTC Visualization Doctoral Dissertation Award</a>. I am honored to be the first recipient graduated from Asia. See the <a href='https://ieeecs-media.computer.org/tc-media/sites/49/2023/10/09182418/Aoyu_Wu_2023_VGTC_Visualization_Dissertation_Award.pdf'  class='url'>official article</a>.",
    },
    {
        date: "2023",
        html: "A finalist for HKUST School of Engineering Research Excellence Award (top 3 from 1000 PhD students in SENG). See the <a href='https://seng.hkust.edu.hk/sites/default/files/styles/horizontal_gallery_image/public/news/10262/SENG_PhD_Rese_Exce_Awar_P20460_01_055.jpg?itok=iAVIjtJm'  class='url'>award ceremony</a>.",
    },
    {
        date: "2023",
        html: '<a href="https://cse.hkust.edu.hk/pg/dissertation_award/2021-22/" class="url">CSE Best PhD Dissertation Award</a>. See the <a href="https://cse.hkust.edu.hk/News/BestDissertation2021-22/#:~:text=We%20are%20pleased%20to%20announce%20that%20the%20recipient%20of%20the,of%20Visualizations%20for%20Data%20Communication." class="url">department announcement</a> and <a href="https://lbezone.hkust.edu.hk/pdfviewer/web/viewer.php?file=aHR0cHM6Ly9sYmV6b25lLmhrdXN0LmVkdS5oay9vYmovMS9vLzk5MTAxMzEwNjM0NTkwMzQxMi85OTEwMTMxMDYzNDU5MDM0MTIucGRm#page=1" class="url">link to my PhD thesis</a>.',
    },
    {
        date: "2022",
        html: "HKUST RedBird Academic Excellence Award for Continuing PhD Students (HKD 20,000).",
    },
    {
        date: "2022",
        html: 'Honorable mention award (top 5%), ACM CHI 2022. See the <a href="https://programs.sigchi.org/chi/2022/program/content/68743" class="url">conference program</a>.',
    },
    {
        date: "2021",
        html: '<a href="https://www.microsoft.com/en-us/research/academic-program/fellowships-microsoft-research-asia/#!fellows" class="url">Microsoft Research Asia Fellowship</a>, a.k.a. <a href="https://www.microsoft.com/en-us/research/academic-program/phd-fellowship/#!people" class="url">Microsoft Research PhD Fellowship</a> (11 in Asia).',
    },
    {
        date: "2019--2022",
        html: '<a href="https://cerg1.ugc.edu.hk/hkpfs/index.html" class="url">Hong Kong PhD Fellowship Scheme</a> (HKD 322,800 annually).',
    },
    {
        date: "2019",
        html: '<span class="">Research & Development Award</span>, 19th Asia Pacific Information and Communications Technology Alliance <a class="url" href="https://apicta.org/">(APICTA)</a> Awards. See the <a href="https://www.info.gov.hk/gia/general/201911/23/P2019112300065.htm?fontSize=1" class="url">press release by the government of HKSAR</a>.',
    },
    {
        date: "2019",
        html: '<span class="" style="">Gold Award</span>, Student Innovation, <a class="url" href="https://www.hkictawards.hk/">Hong Kong ICT Awards (HKICT)</a> 2019, by the Office of the Government Chief Information Officer of Hong Kong.',
    },
    {
        date: "2017",
        html: '<a href="https://publish.ust.hk/aa_medal/" class="url">Academic Achievement Medal</a> (top 1%), HKUST.',
    },
    {
        date: "2017",
        html: '<span><a href="https://www.shss.ust.hk/ug/minor/hm/award/" class="url">Humanities and Social Science Outstanding Performance</a></span>, HKUST.',
    },
    {
        date: "2016",
        html: '<span class="">Lee Hysan Foundation Exchange Scholarship</span>, HKUST.',
    },
    {
        date: "2013--2017",
        html: '<span class="">Undergraduate Admission Scholarship / Kerry Holdings Limited Scholarship</span> (HKD 480,000), HKUST.',
    },
    {
        date: "2013--2017",
        html: '<span class="">Dean\'s List</span>, HKUST (all semesters).',
    },
];

export default defineComponent({
    name: "App",
    components: {},
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });

        return {
            ...toRefs(state),
            awards,
        };
    },
    computed: {},
});
